<ion-header class="alert-settings-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button class="icon back"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ 'ALERT_SETTINGS.ALERT_SETTINGS' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<h4 class="title">{{ 'ALERT_SETTINGS.ALERT_SETTINGS' | translate }} <ion-icon name="close" (click)="onDismiss ? onDismiss() : goBack()"></ion-icon></h4>
<ion-list id="alert-settings-popup">
  <form [formGroup]="alertSettingsForm" (submit)="saveAlertSettings(alertSettingsForm.value)">  
    <ion-item>
      <ion-label>{{ 'ALERT_SETTINGS.CHOOSE_A_KILN' | translate }}</ion-label>
      <ion-note *ngIf="!kilns || (kilns && kilns.length === 0)">
        {{ 'ALERT_SETTINGS.NO_KILNS_FETCHED' | translate }}
      </ion-note>
      <ion-select [placeholder]="'ALERT_SETTINGS.CHOOSE_A_KILN_PLACEHOLDER' | translate" *ngIf="kilns && kilns.length > 0" formControlName="selectedKiln" (ionChange)="selectKilnFromDropdown($event)">
        <ion-select-option *ngFor="let kiln of kilns" [value]="kiln"   
          [class.selected]="selectedKiln ? (selectedKiln.serial_number ? (selectedKiln.serial_number === kiln.serial_number) : (selectedKiln.kiln_id === kiln.kiln_id)) : false" >
          {{kiln.name}}
        </ion-select-option>
      </ion-select>    
    </ion-item>
    <ion-item>
      <ion-label>{{ 'ALERT_SETTINGS.CHOOSE_AN_ALERT' | translate }}</ion-label>
      <ion-select formControlName="selectedAlert" (ionChange)="selectAlert()">
        <ion-select-option *ngFor="let alert of alerts" [value]="alert.type"
          [class.selected]="selectedAlert && selectedAlert.type === alert.type">
          <ion-icon></ion-icon>
          <span>{{alert.name}}</span>
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item lines="none">
      <ion-label slot="start">
        {{ 'ALERT_SETTINGS.CONFIGURE_YOUR_ALERT' | translate }}
        <p *ngIf="selectedAlert">({{selectedAlert.name}})</p>
      </ion-label>
    </ion-item>
    <ion-item *ngIf="showTempVariable() && canAdminister" class="temp-variable">
      <ion-label>{{ 'ALERT_SETTINGS.TEMPERATURE_VARIABLE' | translate }}<sup>*</sup></ion-label>
      <ion-input type="number"
        [class.invalid]="(alertSettingsForm.controls.temp_variable && alertSettingsForm.controls.temp_variable.errors && alertSettingsForm.controls.temp_variable.errors.required) || !alertSettingsForm.controls.temp_variable"
        formControlName="temp_variable"></ion-input>
      <ion-note
        *ngIf="(alertSettingsForm.controls.temp_variable && alertSettingsForm.controls.temp_variable.errors && alertSettingsForm.controls.temp_variable.errors.required) || !alertSettingsForm.controls.temp_variable">
        {{ 'ALERT_SETTINGS.TEMP_VARIABLE_EMPTY' | translate }}
      </ion-note>
    </ion-item>
    <ion-item *ngIf="showTempVariable() && !canAdminister" class="temp-variable">
      <ion-label>{{ 'ALERT_SETTINGS.TEMPERATURE_VARIABLE' | translate }}<sup>*</sup></ion-label>
      <ion-input type="number" readonly="true" disabled="true" [class.readonly]="true"
        [class.invalid]="(alertSettingsForm.controls.temp_variable && alertSettingsForm.controls.temp_variable.errors && alertSettingsForm.controls.temp_variable.errors.required) || !alertSettingsForm.controls.temp_variable"
        formControlName="temp_variable"></ion-input>
    </ion-item>

    <ion-item id="user-select-label">
      <ion-label slot="start">{{ 'ALERT_SETTINGS.SELECT_USERS' | translate }}</ion-label>      
    </ion-item>
    <ion-item id="user-select-list">
      <ion-note *ngIf="gettingUsers"><ion-spinner name="bubbles"></ion-spinner></ion-note>
      <ion-note *ngIf="!gettingUsers && selectedKiln && (!selectedKiln.users || selectedKiln.users && selectedKiln.users.length === 0) && (alertSettingsForm)"
        class="error-users">
        {{ 'ALERT_SETTINGS.NO_USERS_SELECTED' | translate }}
      </ion-note>        
      <ion-list *ngIf="!gettingUsers && selectedKiln" [slot]="" formArrayName="enabled_users" class="enable-disable-users-for-alert" [multiple]="true">
        <ion-item-group *ngFor="let user of enabledUsers().controls; index as user_index" [formGroupName]="user_index" class="checkbox-list-item">
          <ion-item-divider>
            {{user.value.username}}
          </ion-item-divider>
          <ion-item class="checkboxes ion-no-padding" *ngIf="userHasEmail(user_index)">
            <ion-checkbox slot="start" *ngIf="alertSettingsForm && !emailCanAlert(user_index)" [readonly]="true" type="checkbox" readonly='true' aria-label="Select user {{ user.value.username }}"></ion-checkbox>
            <ion-checkbox slot="start" *ngIf="alertSettingsForm && emailCanAlert(user_index)" type="checkbox" formControlName="email_checked"
              (change)="checkboxChange($event, user_index)" aria-label="Select user {{ user.value.username }}"></ion-checkbox>
              <ion-label slot="end">{{user.value.email_label}}</ion-label>
          </ion-item>

          <ng-container formArrayName="phones" *ngIf="userPhoneControls(user_index) && userPhoneControls(user_index).length > 0">
            <ion-item *ngFor="let phone of userPhoneControls(user_index); let phone_index = index;" [formGroupName]="phone_index" class="checkboxes ion-no-padding">
              <ion-checkbox slot="start" class="readonly" *ngIf="alertSettingsForm && (phone && phone.value && !phone.value.can_be_checked)" type="checkbox" readonly='true' aria-label="Select user {{ user.value.username }}"></ion-checkbox>
              <ion-checkbox slot="start" *ngIf="alertSettingsForm && (phone && phone.value && phone.value.can_be_checked)" type="checkbox" formControlName="checked"
                (change)="checkboxChange($event, user_index)" aria-label="Select user {{ user.value.username }}"></ion-checkbox>
              <ion-label slot="end">{{phone.value.label}}</ion-label>
            </ion-item>
          </ng-container>
        </ion-item-group>
      </ion-list>        
    </ion-item>
    <ion-item lines="none" class="verification">
      <ion-note slot="end"><span><sup>*</sup>{{ 'ALERT_SETTINGS.VERIFICATION_NOTE' | translate }}</span></ion-note>
      <ion-note *ngIf="!selectedKiln" slot="end">{{ 'ALERT_SETTINGS.PLEASE_SELECT_KILN' | translate }}</ion-note>
    </ion-item>

    <ion-item class="test-alert-button-container" lines="none">
      <ion-button slot="end" type="button" (click)="testAlert(selectedKiln.mac_address, selectedKiln.serial_number, selectedAlert.type)">{{ 'ALERT_SETTINGS.TEST_ALERT' | translate }}</ion-button>
      <ion-button slot="end" type="submit">{{ 'ALERT_SETTINGS.SAVE' | translate }}</ion-button>
    </ion-item>        
  </form>  
</ion-list>

<ion-item class="buttons">
  <ion-button slot="end" (click)="onDismiss ? onDismiss() : goBack()" class="close">{{ 'ALERT_SETTINGS.CLOSE' | translate }}</ion-button>
  <ion-button slot="end" *ngIf="!savingSettings" [class.disabled]="!alertSettingsForm.valid" class="primary" (click)="saveAlertSettings(alertSettingsForm.value)">{{ 'ALERT_SETTINGS.SAVE' | translate }}</ion-button>
  <ion-button slot="end" *ngIf="savingSettings">
    <ion-spinner name="bubbles"></ion-spinner>
    <span>{{ 'ALERT_SETTINGS.SAVING_SETTINGS' | translate }}</span>
  </ion-button>
</ion-item>
